import React, { useState, useEffect, useMemo } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { removeAlert } from "./../../reducers/userConfigSlice";
// Icons
import {
  TbSquareRoundedCheck,
  TbSquareRoundedX,
  TbAlertSquareRounded,
  TbInfoSquareRounded,
} from "react-icons/tb";
// Styles
import "./style.css";

export const Alert = () => {
  const alerts = useSelector(
    (state) => state.aplicationConfig.userConfig.alerts
  );

  return (
    <div className="alert-container">
      {Array.isArray(alerts) &&
        alerts.map((alert, index) => (
          <AlertComponent key={alert.id} alert={alert} index={index + 1} />
        ))}
    </div>
  );
};

const AlertComponent = ({ alert, index }) => {
  const timeBadge = 3000; // 3 segundos
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    let start = 0;

    const interval = setInterval(() => {
      start += 100 / (timeBadge / 50);
      const clamped = Math.max(0, Math.min(100, start));
      setProgress(clamped);
    }, 50);

    const hideTimeout = setTimeout(() => {
      setIsVisible(false);

      const removeTimeout = setTimeout(() => {
        dispatch(removeAlert(alert.id)); // Eliminar la alerta del estado global
      }, 300); // delay para animación

      // Guardamos el timeout interno para poder limpiarlo
      return () => clearTimeout(removeTimeout);
    }, timeBadge);

    return () => {
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, [alert.id, dispatch]);

  const getColor = (type) => {
    switch (type) {
      case "success":
        return "var(--color-success)";
      case "warning":
        return "var(--color-pending)";
      case "error":
        return "var(--color-error)";
      default:
        return "var(--color-process)";
    }
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case "success":
        return <TbSquareRoundedCheck style={{ color: getColor(type) }} />;
      case "error":
        return <TbSquareRoundedX style={{ color: getColor(type) }} />;
      case "warning":
        return <TbAlertSquareRounded style={{ color: getColor(type) }} />;
      default:
        return <TbInfoSquareRounded style={{ color: getColor(type) }} />;
    }
  };

  const description = useMemo(() => {
    if (typeof alert?.message === "string") return alert.message;
    if (alert?.message == null) return "";
    try {
      return String(alert.message);
    } catch {
      return "";
    }
  }, [alert?.message]);

  return (
    <div
      className={`alert-banner ${isVisible ? "show" : "hide"}`}
      style={{ bottom: `${index * 70}px` }} // Se apilan verticalmente
    >
      <div className="alert-banner-body">
        <div className="message-icon">{getAlertIcon(alert.type)}</div>
        <div>
          <div className="message-title">{alert.title}</div>
          <div className="message-description">{description}</div>
        </div>
      </div>

      <div
        id={"progress-line" + index}
        className="progress-line"
        style={{
          backgroundColor: getColor(alert.type),
          width: `${progress}%`,
        }}
      />
    </div>
  );
};
